export default Object.freeze(
  [
    {
      id: '🌱',
      name: 'New File',
      emojiName: 'seedling',
      action: 'newFilePopToggle',
    },
    {
      name: 'Rename Current File',
      emojiName: 'eyes',
      action: 'renameCurrentFile',
    },
    {
      id: '2️⃣',
      name: 'Copy/Duplicate Current File',
      emojiName: 'two',
      action: 'copyCurrentFile',
    },
    {
      id: '💣',
      name: 'Delete Current File',
      emojiName: 'bomb',
      dangerous: true,
      action: 'deleteCurrentFile',
    },
    {
      id: 'sidebarToggle',
      name: 'Toggle Sidebar',
      emojiName: 'arrowBackward',
      action: 'sidebarToggle',
    },
    {
      id: '🖼',
      name: 'Assets',
      emojiName: 'framedPicture',
      action: 'showAssets',
    },
    {
      id: '🌏',
      name: 'Share Project',
      emojiName: 'earthAsia',
      action: 'sharePopToggle',
    },
    {
      id: '🍱',
      name: 'Embed Project',
      emojiName: 'bentoBox',
      action: 'shareEmbedOverlayToggle',
    },
    {
      id: '🌐',
      name: 'Custom Domains',
      emojiName: 'globeWithMeridians',
      action: 'customDomainPopToggle',
    },
    {
      id: '👯',
      name: 'Share Buttons',
      emojiName: 'dancers',
      action: 'shareButtonsPopToggle',
    },
    {
      id: '🎹',
      name: 'Keyboard Shortcuts',
      emojiName: 'musicalKeyboard',
      action: 'keyboardShortcutOverlayToggle',
    },
    {
      id: '⏪',
      name: 'Rewind Project',
      emojiName: 'rewind',
      action: 'rewindPanelToggle',
    },
    {
      id: '⛑',
      name: 'Toggle Container Stats',
      emojiName: 'helmetWithWhiteCross',
      action: 'containerStatsPanelToggle',
    },
    {
      id: '📰',
      name: 'Toggle Logs',
      emojiName: 'newspaper',
      action: 'logsPanelToggle',
    },
    {
      id: '📟',
      name: 'Open Terminal',
      emojiName: 'pager',
      action: 'openConsole',
    },
    {
      id: '🌈',
      name: 'Project and Editor Settings',
      emojiName: 'rainbow',
      action: 'projectOptionsPopToggle',
    },
    {
      id: '✨',
      name: 'Create New Project',
      emojiName: 'sparkles',
      action: 'newOptionsPopToggle',
    },
    {
      id: '🎤',
      name: 'Remix Project',
      emojiName: 'microphone',
      action: 'remixProject',
    },
    {
      id: '🌺',
      name: 'Switch Project',
      emojiName: 'hibiscus',
      action: 'switchProjectPopToggle',
    },
    {
      id: '🗼',
      name: 'Git, Import, Export',
      emojiName: 'tokyoTower',
      action: 'gitImportExportPopToggle',
    },
    {
      id: 'importGH',
      name: 'Import from GitHub',
      emojiName: 'octocat',
      action: 'importFromGitHub',
    },
    {
      id: 'exportGH',
      name: 'Export to GitHub',
      emojiName: 'octocat',
      action: 'exportToGitHub',
    },
    {
      id: '🐢',
      name: 'Download Project',
      emojiName: 'turtle',
      action: 'downloadProject',
    },
    {
      id: '💤project',
      name: 'Archive this Project',
      emojiName: 'zzz',
      dangerous: true,
      action: 'deleteCurrentProject',
    },
    {
      id: '🎏about',
      name: 'About Glitch',
      emojiName: 'carpStreamer',
      action: 'aboutPopToggle',
    },
    {
      id: '🚑',
      name: 'Community and Support Forum',
      emojiName: 'ambulance',
      url: 'https://support.glitch.com',
    },
    {
      id: '🐶',
      name: 'New Stuff',
      emojiName: 'dogFace',
      action: 'newStuffOverlayToggle',
    },
    {
      id: '🚥',
      name: 'System Status',
      emojiName: 'horizontalTrafficLight',
      url: 'https://status.glitch.com/',
    },
    {
      id: '👩‍💻',
      name: 'Your Account',
      emojiName: 'femaleTechnologist',
      action: 'accountToggle',
    },
    {
      id: '🌙',
      name: 'Change Theme',
      emojiName: 'crescentMoon',
      action: 'changeTheme',
    },
    {
      id: '🌀',
      name: 'Toggle Refresh App on Changes',
      emojiName: 'cyclone',
      action: 'refreshPreviewOnChangesToggle',
    },
    {
      id: '🔁',
      name: 'Toggle Wrap Text',
      emojiName: 'refresh',
      action: 'wrapTextToggle',
    },
    {
      id: '👓',
      name: 'Show App Next to The Code',
      emojiName: 'eyeglasses',
      action: 'toggleAppPreview',
    },
  ].map(Object.freeze),
);
